import React from "react";
import { BidFormValues } from "./types";
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

const DiscountAndFees = ({ form }: { form: UseFormReturn<BidFormValues> }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="additionalFee"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Setup, Takedown, Delivery</FormLabel>
            <FormControl>
              <div className="flex items-center border rounded-md px-3 shadow-sm">
                <span className="text-muted-foreground">$</span>
                <Input
                  type="number"
                  placeholder="0"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value === ""
                        ? undefined
                        : Number(e.target.value),
                    )
                  }
                  className="border-none focus-visible:ring-0 focus-visible:ring-offset-0 pl-1"
                />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="extraPayPerDealer"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Extra Pay Per Dealer (if its far away or a long party)
            </FormLabel>
            <FormControl>
              <div className="flex items-center border rounded-md px-3 shadow-sm">
                <span className="text-muted-foreground">$</span>
                <Input
                  type="number"
                  placeholder="0"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value === ""
                        ? undefined
                        : Number(e.target.value),
                    )
                  }
                  className="border-none focus-visible:ring-0 focus-visible:ring-offset-0 pl-1"
                />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="discountAmount"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Discount Amount</FormLabel>
            <FormControl>
              <div className="flex items-center border rounded-md px-3 shadow-sm">
                <span className="text-muted-foreground">$</span>
                <Input
                  type="number"
                  placeholder="0"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value === ""
                        ? undefined
                        : Number(e.target.value),
                    )
                  }
                  className="border-none focus-visible:ring-0 focus-visible:ring-offset-0 pl-1"
                />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default DiscountAndFees;
